<!--
 * @Description: 预采购任务弹层
 * @Date: 2022-03-09 13:47:17
-->
<template>
  <el-dialog
    title="预采购任务"
    :visible="true"
    width="650px"
    top="5vh"
    :before-close="() => $emit('close')"
  >
    <el-form
      ref="form"
      :model="form"
      class="demo-form-inline"
      :rules="formRules"
      label-suffix=" : "
      label-width="150px"
      label-position="right"
      size="mini"
    >
      <el-form-item label="预采购时间" prop="taskDt">
        <el-date-picker
          v-model="form.taskDt"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="预采购任务量">
        <el-row :gutter="10" type="flex" justify="start">
          <el-button
            size="medium"
            type="text"
            icon="el-icon-download"
            plain
            @click="download('history')"
          >
            下载剩余量
          </el-button>
          <el-button
            size="medium"
            type="text"
            icon="el-icon-download"
            plain
            @click="download('dataTemplate')"
          >
            下载数据模板
          </el-button>
        </el-row>
        <el-upload
          class="upload-demo"
          ref="upload"
          :action="actionUrl"
          :drag="true"
          :multiple="false"
          :auto-upload="false"
          :headers="headers"
          :data="form"
          :withCredentials="true"
          :limit="1"
          :on-exceed="uploadExceed"
          :on-success="uploadSuccess"
          :before-upload="beforeUpload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            上传格式为 xls 或 xlsx 文件，最大支持20M
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item v-if="isBaseOperate" label="导入方式" prop="importType">
        <el-select
          @change="form.taskShowType = ''"
          v-model="form.importType"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="showOverwrite" label="覆盖方式" prop="taskShowType">
        <el-radio v-model="form.taskShowType" :label="3">
          按当前表单执行本期任务量
        </el-radio>
        <p style="color:#f56c6c">
          不存在于导入表单的项目执行人任务量将全部为0
        </p>
        <el-radio v-model="form.taskShowType" :label="1">
          修改当前表单内项目执行人的任务量
        </el-radio>
        <p style="color:#f56c6c">
          只覆盖当前导入表单内项目执行人任务量,其他人保持原有数量
        </p>
      </el-form-item>
      <el-form-item
        v-if="showAccumulation"
        label="累加方式"
        prop="taskShowType"
      >
        <el-radio v-model="form.taskShowType" :label="4">
          按当前表单执行本期任务量
        </el-radio>
        <p style="color:#f56c6c">
          当前表单内项目执行人任务量与剩余量进行累加,不存在于导入表单的项目执行人的任务量将全部为0
        </p>
        <el-radio v-model="form.taskShowType" :label="5">
          修改当前表单内项目执行人的任务量
        </el-radio>
        <p style="color:#f56c6c">
          只累加当前导入表单内项目执行人任务量,其他人保持原有数量
        </p>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-row type="flex" justify="space-between">
        <el-button size="medium" type="danger" plain @click="removeLatestTask">
          上期预采购任务量清零
        </el-button>
        <div>
          <el-button @click="$emit('close')">取 消</el-button>
          <el-button type="primary" @click="uploadSubmit" :loading="btLoading">
            确 定
          </el-button>
        </div>
      </el-row>
    </span>
  </el-dialog>
</template>

<script>
import { btLoading } from '@/Mixin/btLoading';
import { getToken } from '@/tools/auth';
import { mapState } from 'vuex';
import {
  importProjectTaskPlanDel,
  projectTaskPlanExcel,
  projectTaskPlanTemplate,
  importProjectPeople
} from '@/api/ajax.js';
import Config from '@/config/index';
import createExtend from '@C/createExtend';
import ImportFailTable from './import-fail-table.vue';
export default {
  name: 'preBuy',
  mixins: [btLoading],
  data() {
    const checkImportType = (rule, value, callback) => {
      // 没上传过文件
      if (!this.isImported && this.isBaseOperate && !value) {
        callback(new Error('请选择导入方式'));
        return;
      }
      // 再次上传文件
      if (
        this.$refs.upload.uploadFiles.length &&
        this.isBaseOperate &&
        !value
      ) {
        callback(new Error('请选择导入方式'));
        return;
      }
      // 有上传过文件，没选择方式可以提交
      callback();
    };
    const checkTaskShowType = (rule, value, callback) => {
      // 没上传过文件
      if (!this.isImported && !value) {
        callback(new Error('请选择方式'));
        return;
      }
      // 再次上传文件
      if (this.$refs.upload.uploadFiles.length && !value) {
        callback(new Error('请选择方式'));
        return;
      }
      // 有上传过文件，没选择方式可以提交
      callback();
    };

    return {
      options: [
        {
          label: '覆盖原数据',
          value: 1
        },
        {
          label: '累加原数据',
          value: 2
        }
      ],
      form: {
        redisKey: '',
        importType: '', // 导入方式,仅基地有该项 0未选择， 1覆盖，2累加
        isProjectPeopleSkip: 0, // 项目人员提示是否跳过勾选  0 没有 （默认）1 是
        taskPlanExcelVoListStr: '', // 修改的数据集合  字符串
        secondaryConfirmation: 0, // 是否二次确认  0否 1是 默认是0
        taskDt: '',
        projectId: '',
        taskShowType: 0 // 覆盖方式0 代表不传文件  1覆盖（修改当前表单内自然人的任务量） 2追加-暂停使用 ， 3 按当前表单执行本期任务量-其余人清0， 4追加-其余人为0，5追加-其余人不变
      },
      formRules: {
        taskDt: [
          {
            required: true,
            message: '请选择日期',
            trigger: 'blur'
          }
        ],
        taskShowType: [{ validator: checkTaskShowType, trigger: 'change' }],
        importType: [{ validator: checkImportType, trigger: 'change' }]
      },
      headers: {},
      pickerOptions: {
        disabledDate(time) {
          const cur = new Date();
          const curDate = cur.getDate() - 1;
          cur.setDate(curDate);
          return time.getTime() < cur.getTime();
        }
      },
      uploadLoading: null // 上传loading
    };
  },
  computed: {
    ...mapState({
      projectInfo: state => state.homeProject
    }),
    // baseOperateBaseData 1运营基地
    isBaseOperate() {
      return this.projectInfo.baseOperateBaseData === 1;
    },
    // 提交地址
    actionUrl() {
      return importProjectPeople.importExcelNewActionUrl;
    },
    // 是否已上传过文件，如果上传过文件可以直接提交(不需要再次上传及选择导入等方式)。如果再次上传必须选择导入等方式，如果选择了方式必须在上传文件。
    isImported() {
      return this.projectInfo.whetherExcelHasBeenImported === 1; // 1表示已上传附件 0表示没有
    },
    // 是否展示覆盖选项
    showOverwrite() {
      // 普通ASP与基地-覆盖方式 展示
      return this.form.importType === 1 || !this.isBaseOperate;
    },
    // 是否展示累加选项
    showAccumulation() {
      // 仅基地-累加方式 展示
      return this.form.importType === 2 && this.isBaseOperate;
    }
  },
  watch: {
    projectInfo: {
      deep: true,
      immediate: true,
      handler({ projectTaskPlan, id }) {
        this.form.projectId = id;
        projectTaskPlan && (this.form.taskDt = projectTaskPlan);
      }
    }
  },
  methods: {
    async removeLatestTask() {
      await this.$confirm('此操作将清零上期预采购任务量, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });

      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      try {
        await importProjectTaskPlanDel({
          projectId: this.form.projectId
        });
        this.$message({
          message: '上期预采购任务量已清零',
          type: 'success'
        });
        loading.close();
      } catch (e) {
        loading.close();
      }
    },
    download(type) {
      switch (type) {
        // 下载数据模板
        case 'dataTemplate':
          this.$downloadFile(
            `${projectTaskPlanTemplate}?projectId=${this.form.projectId}`,
            true
          );
          break;
        //下载历史导入量
        case 'history':
          this.$downloadFile(
            `${projectTaskPlanExcel}?projectId=${this.form.projectId}`,
            true
          ).then(res => {
            const { message, status } = res;
            if (+status === 0) {
              this.$msgbox({
                message,
                type: 'info'
              });
            }
          });
          break;
      }
    },
    // 修改file state，方便调用upload submit再次提交
    changeFileState() {
      const upload = this.$refs.upload;
      upload.uploadFiles.length && (upload.uploadFiles[0].status = 'ready');
    },
    // 提交 预采购任务
    async uploadSubmit() {
      this.form.secondaryConfirmation = 0; // 重置为第一次提交
      const upload = this.$refs.upload;
      const uploadFilesLen = upload.uploadFiles.length;
      // 验证表单
      await this.$refs.form.validate();
      // 需要上传
      if (
        !uploadFilesLen &&
        (!this.isImported || this.form.importType || this.form.taskShowType)
      ) {
        this.$message({
          message: '请选择上传文件',
          type: 'error'
        });
        return;
      }
      // 无需上传 直接提交
      if (!uploadFilesLen && this.isImported) {
        const {
          data: { message }
        } = await importProjectPeople.importExcelNew(this.form);
        this.$message({
          message: message,
          type: 'success'
        });
        // 提交成功
        this.$emit('ok');
        this.$emit('remove');
        return;
      }
      // 有文件
      upload.uploadFiles.length && upload.submit();
    },
    // 文件 个数超过限制时 清空旧的列表 新增新的文件
    uploadExceed(files) {
      const upload = this.$refs.upload;
      upload.clearFiles();
      upload.handleStart(files[0]);
    },
    beforeUpload() {
      // 防止确定后用户关闭弹层
      this.uploadLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    // 上传成功
    uploadSuccess(response) {
      this.uploadLoading.close();
      const upload = this.$refs.upload;
      const { status, message, code, data } = response;
      this.form.redisKey = data.redisKey || '';
      if (+status === 1) {
        // 二次确认
        if (+code === 2) {
          this.form.secondaryConfirmation = 1; // 修改二次提交标识
          const h = this.$createElement;
          this.$msgbox({
            title: '是否继续',
            message: h('div', { style: 'text-align:center' }, [
              h('p', null, message),
              h(
                'el-checkbox',
                {
                  style: 'margin-top:15px',
                  on: {
                    input: v => {
                      // 设置是否展示
                      this.form.isProjectPeopleSkip = +v;
                    }
                  }
                },
                '本项目不再提示'
              )
            ]),
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            closeOnPressEscape: false,
            beforeClose: async (action, instance, done) => {
              // 直接修改el中文件状态，方便下次直接调用submit进行提交及第二次提交依然需要文件流
              this.changeFileState();
              if (action === 'confirm') {
                upload.submit();
              }
              // 操作都会关闭该弹层
              done();
            }
          });
        } else if (+code === 3) {
          // 展示错误列表
          const errorTable = createExtend(ImportFailTable, {
            fileForm: this.form
          });
          errorTable.$on('removeRedisKey', () => {
            this.form.redisKey = '';
          });
          errorTable.$on('ok', () => {
            this.$emit('ok');
          });
          errorTable.$on('remove', () => {
            this.changeFileState();
          });
        } else {
          // 提交成功
          this.$emit('ok');
          this.$emit('remove');
        }
      } else {
        upload.clearFiles();
        this.$alert(message, '导入失败', {
          type: 'error',
          center: true
        });
      }
    }
  },
  created() {
    this.headers[Config.token] = getToken();
  }
};
</script>

<style scoped>
/deep/ .el-upload-list__item-name {
  width: 360px;
  background: #eef4fb;
  /*color: #fff;*/
}
</style>
